var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwordActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86446 14.0828L11.7618 10.6911C12.2371 10.3578 12.2371 9.65781 11.7618 9.33281L6.86446 5.93281C6.2958 5.54948 5.52344 5.94115 5.52344 6.61615V13.3995C5.52344 14.0745 6.2958 14.4661 6.86446 14.0828ZM14.0109 5.84115V14.1745C14.0109 14.6328 14.3929 15.0078 14.8597 15.0078C15.3265 15.0078 15.7084 14.6328 15.7084 14.1745V5.84115C15.7084 5.38281 15.3265 5.00781 14.8597 5.00781C14.3929 5.00781 14.0109 5.38281 14.0109 5.84115Z",
    fill: "#8F4300",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwordActive);
export default __webpack_public_path__ + "static/media/Forword_active.e777ca2d82aefecf1a104496023db51d.svg";
export { ForwardRef as ReactComponent };